module.exports = __webpack_public_path__ + "img/x-circle-contained.77e2658a.svg";